import { createTheme, type ThemeOptions } from "@mui/material/styles";

/**
 * Business-neutral theme tokens. Swap the palette/typography here to
 * rebrand the whole app — components should never hardcode colors.
 */
const sharedOptions: ThemeOptions = {
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
};

export const lightTheme = createTheme({
  ...sharedOptions,
  palette: {
    mode: "light",
    primary: { main: "#3653F4" },
    secondary: { main: "#6B7280" },
    background: { default: "#F7F8FA", paper: "#FFFFFF" },
  },
});

export const darkTheme = createTheme({
  ...sharedOptions,
  palette: {
    mode: "dark",
    primary: { main: "#7C8CFF" },
    secondary: { main: "#9CA3AF" },
    background: { default: "#0F1115", paper: "#171A21" },
  },
});

export type ThemeMode = "light" | "dark";

export function getTheme(mode: ThemeMode) {
  return mode === "dark" ? darkTheme : lightTheme;
}
